<template>
	<div
		:class="{play}"
		class="music_wrap"
		ref="music"
		id="music_wrap"
	>
		<div class="yinjie">
			<span class="dou"></span>
			<span class="dou2"></span>
		</div>
		<div :class="{guang:true,rotate:true}">
			<span class="outline"></span>
			<span class="icon"></span>
		</div>
	</div>
</template>
<script>
import BgSound from "ztgamejs/bgsound";
export default {
	data() {
		return {
			play: false,
		};
	},

	mounted() {
    if(window.isDev){
      return;
    }
    this.play = true;
		this.sound = new BgSound({
			file: "http://spdbtech.mirror2.h5.yscase.com/sound/bg.mp3",
			autoPlay: true,
			onplay() {
				this.play = true;
			},
			onpause() {
				this.play = false;
			},
		});
		this.$refs.music.addEventListener(
			"touchstart",
			(e) => {
				if (this.play) {
					this.sound.pause();
					this.play = false;
				} else {
					this.sound.play();
					this.play = true;
				}
			},
			false
		);
	},
};
</script>
<style scoped lang="less">
.music_wrap {
	width: 1.2rem;
	white-space: nowrap;

	.yinjie {
		display: inline-block;
		vertical-align: middle;
		height: 0.22rem;
		position: relative;
		// display: inline-flex;
		// position: relative;
		// align-items: flex-end;
		span {
			display: inline-block;
			width: 0.1rem;
			height: 100%;
			background: url("../assets/jie.png") no-repeat center bottom/100%
				auto;
			margin: 0 0.03rem;
		}
	}
	.guang {
		display: inline-block;
		vertical-align: middle;
		width: 0.7rem;
		height: 0.7rem;
		background: url("../assets/guang.png") no-repeat center/contain;
		position: relative;
		display: inline-flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-left: 0.1rem;
		.outline {
			width: 100%;
			height: 100%;
			background: url("../assets/guang.png") no-repeat center/contain;
			position: absolute;
			left: 0;
			top: 0;
		}
		.icon {
			width: 0.33rem;
			height: 0.33rem;
			display: inline-block;
			background: url("../assets/music.png") no-repeat center/contain;
		}
	}
}
#music_wrap {
	* {
		animation-play-state: paused;
	}
}
.rotate {
	animation: rotate 3s linear 0s infinite both;
}
@keyframes rotate {
	0% {
		transform: rotate(0);
	}
	100% {
		transform: rotate(360deg);
	}
}
.dou {
	animation: dou 0.3s ease-in-out 0s infinite alternate-reverse both;
}
.dou2 {
	animation: dou2 0.3s ease-in-out 0s infinite alternate-reverse both;
}
@keyframes dou {
	0% {
		height: 30%;
	}
	100% {
		height: 100%;
	}
}
@keyframes dou2 {
	0% {
		height: 10%;
	}
	100% {
		height: 80%;
	}
}
#music_wrap.play {
	* {
		animation-play-state: running;
	}
}
</style>